import SearchPage from './features/search/page'
import {
  // Home,
  // About,
  TermsConditions,
  Faq,
  Contact,
  Organization,
  Event,
  EventRegister,
  Program,
  // ProgramStatistic,
  // ProgramStatisticOrganization,
  ProgramMap,
  Resource,
  Blog,
  OrganizationMap,
  // OrganizationStatistic,
  OrganizationDetail,
  // EventDetail,
  BlogDetail,
  // ResourceDetail,
  SearchResults,
  Register,
  RegisterOrganization,
  RegisterOrganizationConfirmation,
  Login,
  ForgotPassword,
  // ProgramDetail,
  // Dashboard,
  DashboardProfile,
  DashboardBookmarks,
  DashboardSettings,
  DashboardVisibility,
  DashboardTickets,
  // DashboardPrograms,
  DashboardEvents,
  DashboardResources,
  DashboardBlog,
  DashboardMilestonesForm,
  DashboardPartnersForm,
  DashboardLocationForm,
  DashboardGuestList,
  DashboardGuestDetail,
  Profile,
  ProgramStory,
  DashboardProfileOrganization,
  Career,
  // Dev,
  Version,
  EmbedLinkExample,
  // Landing,
} from './pages'
import Impact from './pages/dashboard-programs/update/impact'
import Api from './pages/_api'

const routes = [
  // {
  //   path: "/_dev",
  //   component: Dev,
  //   private: true,
  // },
  {
    path: "/_api",
    component: Api,
    private: true,
  },
  {
    path: "/search",
    component: SearchPage,
  },
  {
    path: "/dashboard/programs/update/:id/impact",
    component: Impact,
    private: true,
  },
  {
    path: "/dashboard/organization/profile/partners/form/:id",
    component: DashboardPartnersForm,
    private: true,
  },
  {
    path: "/dashboard/organization/profile/partners/form",
    component: DashboardPartnersForm,
    private: true,
    exact: true,
  },
  {
    path: "/dashboard/organization/profile/location/edit",
    component: DashboardLocationForm,
    private: true,
  },
  {
    path: "/dashboard/organization/profile/milestones/form/:id",
    component: DashboardMilestonesForm,
    private: true,
  },
  {
    path: "/dashboard/organization/profile/milestones/form",
    component: DashboardMilestonesForm,
    private: true,
    exact: true,
  },
  {
    path: "/dashboard/organization/profile",
    component: DashboardProfileOrganization,
    private: true,
    roles: [2]
  },

  /* Dashboard moved to App.js due to special routing case reason (Lazy Loading). */
  // {
  //   path: "/dashboard",
  //   component: Dashboard,
  //   exact: true,
  //   private: true,
  //   roles: [1, 2]
  // },
  {
    path: "/blog/:id/detail",
    component: BlogDetail
  },
  {
    path: "/blog",
    component: Blog
  },
  // {
  //   path: "/resource/:id/detail",
  //   component: ResourceDetail
  // },
  {
    path: "/resource",
    component: Resource
  },
  {
    path: "/program-map",
    component: ProgramMap
  },
  // {
  //   path: "/program-statistic-organization",
  //   component: ProgramStatisticOrganization
  // },
  // {
  //   path: "/program-statistic",
  //   component: ProgramStatistic
  // },
  {
    path: "/program/:id/story",
    component: ProgramStory
  },
  // {
  //   path: "/program/:id/detail",
  //   component: ProgramDetail
  // },
  {
    path: "/program",
    component: Program
  },
  {
    path: "/event/:id/register",
    component: EventRegister
  },
  // {
  //   path: "/event/:id/detail",
  //   component: EventDetail
  // },
  {
    path: "/event",
    component: Event
  },
  {
    path: "/organization/:id",
    component: OrganizationDetail
  },
  // {
  //   path: "/organization-statistic",
  //   component: OrganizationStatistic
  // },
  {
    path: "/organization-map",
    component: OrganizationMap
  },
  {
    path: "/organization",
    component: Organization
  },
  {
    path: "/profile/:id",
    component: Profile
  },
  {
    path: "/profile",
    component: Profile
  },
  {
    path: "/career",
    component: Career
  },
  // {
  //   path: "/about",
  //   component: Landing
  // },
  {
    path: "/terms-conditions",
    component: TermsConditions
  },
  {
    path: "/faq",
    component: Faq
  },
  {
    path: "/contact",
    component: Contact
  },
  {
    path: "/search-results",
    component: SearchResults
  },
  {
    path: "/login/requirement",
    component: Login,
    required: true
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/register",
    component: Register
  },
  {
    path: "/register-organization",
    component: RegisterOrganization
  },
  {
    path: "/register-organization-confirmation",
    component: RegisterOrganizationConfirmation
  },
  {
    path: "/forgot-password",
    component: ForgotPassword
  },
  {
    path: "/example/embed-link",
    component: EmbedLinkExample
  },
  {
    path: "/version",
    component: Version
  },

  /* Home moved to App.js due to special routing case reason (404 Handling). */
  // {
  //   path: "/",
  //   component: Home,
  //   exact: true
  // },
]

const dashboardRoutes = [
  {
    path: "/dashboard/profile",
    component: DashboardProfile
  },
  {
    path: "/dashboard/bookmarks",
    component: DashboardBookmarks
  },
  {
    path: "/dashboard/tickets",
    component: DashboardTickets
  },
  {
    path: "/dashboard/visibility",
    component: DashboardVisibility
  },
  {
    path: "/dashboard/settings",
    component: DashboardSettings
  },
  {
    path: "/dashboard/events/:eventId/guest-list/:id",
    component: DashboardGuestDetail,
  },
  {
    path: "/dashboard/events/:id/guest-list",
    component: DashboardGuestList,
  },
  {
    path: "/dashboard/events",
    component: DashboardEvents,
    exact: true
  },
  {
    path: "/dashboard/resources",
    component: DashboardResources,
  },
  {
    path: "/dashboard/blog",
    component: DashboardBlog
  },
  // {
  //   path: "/dashboard/programs",
  //   component: DashboardPrograms
  // },
]

export { dashboardRoutes }

export default routes
